import { IArticleAndInsights } from "../types/articles-and-insights-type.types";
import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export const getNewFeedArticles = async () => {
  const response = await request<IArticleAndInsights[]>({
    method: "GET",
    url: API_PATHS.newFeedArticles,
  });
  return response;
};
